var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChefHat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.506,
    height: 15.496,
    viewBox: "0 0 15.506 15.496",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chapeau-chef",
    d: "M15.391,3.04a3.489,3.489,0,0,0-4.957-1.992,3.978,3.978,0,0,0-5.373,0C.907-1.069-2.319,4.993,2.145,6.92a.6.6,0,0,1,.435.55v5.125A2.906,2.906,0,0,0,5.487,15.5h4.521a2.906,2.906,0,0,0,2.906-2.906V7.469a.6.6,0,0,1,.435-.55,3.24,3.24,0,0,0,2.042-3.88Zm-3.769,9.554a1.614,1.614,0,0,1-1.614,1.614H5.487a1.671,1.671,0,0,1-1.614-1.937h7.749ZM12.913,5.7a1.881,1.881,0,0,0-1.292,1.767V10.98H3.872V7.469A1.881,1.881,0,0,0,2.581,5.7,1.955,1.955,0,0,1,1.354,3.36,2.148,2.148,0,0,1,4.7,2.391a.65.65,0,0,0,1-.09,2.585,2.585,0,0,1,4.1,0,.65.65,0,0,0,1,.09,2.046,2.046,0,0,1,1.873-.414h0A1.946,1.946,0,0,1,12.913,5.7Z",
    transform: "translate(0.007 -0.004)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChefHat);
export default __webpack_public_path__ + "static/media/chef_hat.da5b767476e29c357b6f37c56a45e3e2.svg";
export { ForwardRef as ReactComponent };